// PrintWorkerCard.js
import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

export default function PrintWorkerCard({ dataState, sortedProfessions, selectedOption }) {
   return (
      <div className="print-card">
         <div className="cardHeader">
            <h3>{selectedOption.label}</h3>
         </div>

         <div className="cardMain">
            <div className="top">
               <div className="topLeft">
                  <h3 className="workerName">{dataState.fullName}</h3>
                  <span className="mainJob">
                     Посада:<br />{dataState.position}
                  </span>
               </div>
               <div className="topRight">
                  <img
                     className="workerImg"
                     alt="photo"
                     src={`${process.env.REACT_APP_SERVER_URL}/${dataState?.photo?.contentUrl}`}
                  />
               </div>
            </div>

            <div className="bottom">
               <div className="bottomLeft">
                  <h3>Перелік професій</h3>
                  <div className="studiing">
                     {sortedProfessions.map((elem) => (
                        <div className="studiing__block" key={elem.id}>
                           <span className={sortedProfessions.length < 9 ? 'fontLarge' : 'fontSmall'}>
                              {elem.workerProffessionList.name}
                           </span>
                        </div>
                     ))}
                  </div>
               </div>
               <div className="bottomRight">
                  <QRCodeSVG
                     value={`${process.env.REACT_APP_SITE_URL}/workers/update/${dataState.id}`}
                     className="qr"
                  />
               </div>
            </div>
         </div>

         <div className="cardFooter">
            <h3 className="cardFooterCode">{`№ картки ${dataState.code1c || '-'}`}</h3>
            <div className="cardFooter__date">
               <h3>Дата формування:<br />{new Date().toLocaleDateString()}</h3>
            </div>
         </div>
      </div>
   );
}
